var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.334 14.3334C18.334 15.0834 18.1257 15.7917 17.7507 16.3917C17.059 17.5501 15.7923 18.3334 14.334 18.3334C12.8757 18.3334 11.6006 17.5501 10.9173 16.3917C10.5506 15.7917 10.334 15.0834 10.334 14.3334C10.334 12.1251 12.1257 10.3334 14.334 10.3334C16.5423 10.3334 18.334 12.1251 18.334 14.3334Z",
    stroke: "#0E1111",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7754 14.3334L13.7587 15.3168L15.8921 13.3501",
    stroke: "#0E1111",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3327 7.24173C18.3327 8.8834 17.9077 10.3334 17.241 11.5917C16.5077 10.8167 15.4743 10.3334 14.3327 10.3334C12.1243 10.3334 10.3327 12.1251 10.3327 14.3334C10.3327 15.3584 10.7243 16.2917 11.3577 17.0001C11.0493 17.1417 10.766 17.2584 10.516 17.3417C10.2327 17.4417 9.76602 17.4417 9.48268 17.3417C7.06602 16.5167 1.66602 13.0751 1.66602 7.24173C1.66602 4.66673 3.74102 2.58337 6.29935 2.58337C7.80768 2.58337 9.15768 3.31674 9.99935 4.44174C10.841 3.31674 12.191 2.58337 13.6993 2.58337C16.2577 2.58337 18.3327 4.66673 18.3327 7.24173Z",
    stroke: "#0E1111",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartTick);
export default __webpack_public_path__ + "static/media/heart-tick.e44cfb16ac49d2d14636b0d8e71e36af.svg";
export { ForwardRef as ReactComponent };